// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_option from "../../../../../../node_modules/rescript/lib/es6/js_option.js";
import * as CountryContext from "../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as SidePanelFooter from "./SidePanelFooter.bs.js";
import * as SidePanelHeader from "./SidePanelHeader.bs.js";
import * as Sidebar$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/sidebar/Sidebar.bs.js";
import * as SendSmsStepperCmp from "./send-sms/SendSmsStepperCmp.bs.js";
import * as SendSmsDataMachine from "../../app/repo/SendSmsDataMachine.bs.js";
import * as SmsUserProfileDetailsCmp from "./send-sms/SmsUserProfileDetailsCmp.bs.js";
import * as SendSMSSideBarStateMachine from "./send-sms/SendSMSSideBarStateMachine.bs.js";

function SendSmsSidePanelCmp(Props) {
  var selected_user = Props.selected_user;
  var show_side_panel = Props.show_side_panel;
  var set_show_sidepanel = Props.set_show_sidepanel;
  var openSnackbar = Props.openSnackbar;
  var fetchSmsList = Props.fetchSmsList;
  var on_back_drop_click = Props.on_back_drop_click;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = React.useReducer(SendSMSSideBarStateMachine.reducer, {
        currentStepperState: /* SelectTemplate */0,
        templateList: {
          TAG: /* Loading */0,
          _0: undefined
        },
        selectedTemplate: undefined
      });
  var dispatch = match$1[1];
  var state = match$1[0];
  var match$2 = React.useState(function () {
        return false;
      });
  var toggleLoader = match$2[1];
  React.useEffect((function () {
          SendSmsDataMachine.fetchSmsTemplateList(country, (function (data) {
                  return Curry._1(dispatch, {
                              TAG: /* SetTemplateList */1,
                              templateList: {
                                TAG: /* Live */1,
                                _0: data
                              }
                            });
                }), (function (error) {
                  return Curry._1(openSnackbar, {
                              TAG: /* Error */1,
                              _0: "Submission Failed! Error : API link broken. Please Try submitting again"
                            });
                }));
          
        }), []);
  var form = SmsUserProfileDetailsCmp.CheckBoxForm.useForm({
        primary_mobile_number: true,
        secondary_mobile_number: false
      }, (function (param, param$1) {
          
        }));
  var toggleSidebar = function (param) {
    var match = state.currentStepperState;
    if (match) {
      return Curry._1(on_back_drop_click, undefined);
    } else {
      return Curry._1(set_show_sidepanel, false);
    }
  };
  var getSendSmsMessageRequestParams = function (selectedUser) {
    var secondaryMobileNumber = selectedUser.secondary_mobile_number;
    var selectedTemplate = state.selectedTemplate;
    return {
            primary_phone_number: form.input.primary_mobile_number ? selectedUser.primary_mobile_number : "",
            secondary_phone_number: form.input.secondary_mobile_number && secondaryMobileNumber !== undefined ? secondaryMobileNumber : undefined,
            template_id: selectedTemplate !== undefined ? selectedTemplate.template_id : 0
          };
  };
  var onSubmitOrNextButtonClick = function (param) {
    var match = state.currentStepperState;
    if (match) {
      if (selected_user === undefined) {
        return Curry._1(openSnackbar, {
                    TAG: /* Error */1,
                    _0: "Submission Failed! Error : API link broken. Please Try submitting again"
                  });
      }
      var selectedTemplate = state.selectedTemplate;
      Curry._1(toggleLoader, (function (param) {
              return true;
            }));
      return SendSmsDataMachine.sendSmsMessage(getSendSmsMessageRequestParams(selected_user), (function (data) {
                    Curry._1(toggleLoader, (function (param) {
                            return false;
                          }));
                    if (selectedTemplate !== undefined) {
                      var match = data.status_code;
                      if (match !== 200) {
                        return Curry._1(openSnackbar, {
                                    TAG: /* Error */1,
                                    _0: "Submission Failed! Error : API link broken. Please Try submitting again"
                                  });
                      } else {
                        Curry._1(openSnackbar, {
                              TAG: /* Success */0,
                              _0: "Request to send " + selectedTemplate.template_title + "( " + String(selectedTemplate.template_id) + " ) has been sent"
                            });
                        Curry._1(set_show_sidepanel, false);
                        return Curry._1(fetchSmsList, selected_user.primary_mobile_number);
                      }
                    } else {
                      return Curry._1(set_show_sidepanel, true);
                    }
                  }), (function (error) {
                    Curry._1(toggleLoader, (function (param) {
                            return false;
                          }));
                    return Curry._1(openSnackbar, {
                                TAG: /* Error */1,
                                _0: "Submission Failed! Error : API link broken. Please Try submitting again"
                              });
                  }), country);
    } else {
      return Curry._1(dispatch, {
                  TAG: /* CurrentStepperState */0,
                  currentStepperState: /* TemplateDetails */1
                });
    }
  };
  var onBackButtonClick = function (param) {
    return Curry._1(dispatch, {
                TAG: /* CurrentStepperState */0,
                currentStepperState: /* SelectTemplate */0
              });
  };
  var onSelectTemplate = function (template) {
    return Curry._1(dispatch, {
                TAG: /* SelectTemplate */2,
                selectedTemplate: template
              });
  };
  var isSubmitButtonEnabled = React.useMemo((function () {
          var isSelectedTemplate = Js_option.isSome(state.selectedTemplate);
          if (form.input.primary_mobile_number || form.input.secondary_mobile_number) {
            return isSelectedTemplate;
          } else {
            return false;
          }
        }), [
        form.input.primary_mobile_number,
        form.input.secondary_mobile_number,
        state
      ]);
  return React.createElement(Sidebar$Catalyst.make, {
              open: show_side_panel,
              toggleSidebar: toggleSidebar,
              children: React.createElement("div", {
                    className: "sendsms-side-panel-content"
                  }, React.createElement(SidePanelHeader.make, {
                        on_close_click: toggleSidebar,
                        heading: "Send Message",
                        class_name: "sendsms-header"
                      }), React.createElement("div", {
                        className: "sendsms-sidepanel-body"
                      }, React.createElement(SmsUserProfileDetailsCmp.make, {
                            user_data: selected_user,
                            form: form
                          }), React.createElement(SendSmsStepperCmp.make, {
                            current_stepper_state: state.currentStepperState,
                            template_list: state.templateList,
                            on_select_template: onSelectTemplate,
                            selected_template: state.selectedTemplate
                          })), React.createElement(SidePanelFooter.make, {
                        on_primary_btn_click: onSubmitOrNextButtonClick,
                        on_secondary_btn_click: onBackButtonClick,
                        show_secondary_btn: state.currentStepperState === /* TemplateDetails */1,
                        is_disabled: !isSubmitButtonEnabled,
                        is_loading: match$2[0],
                        class_name: "sendsms-footer",
                        loader_msg: "Message is being sent out ..."
                      })),
              classes: {
                root: "sendsms-side-panel",
                docked: "",
                paper: "",
                paperAnchorLeft: "",
                paperAnchorRight: "w-25",
                paperAnchorTop: "",
                paperAnchorBottom: "",
                paperAnchorDockedLeft: "",
                paperAnchorDockedTop: "",
                paperAnchorDockedRight: "",
                paperAnchorDockedBottom: "",
                modal: ""
              }
            });
}

var make = SendSmsSidePanelCmp;

export {
  make ,
  
}
/* react Not a pure module */
